import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function SupportSection() {
  return <section id="support" className="py-20 bg-[#0f5f5f] text-white relative overflow-hidden" data-id="element-178">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" data-id="element-179" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#d4a74a]/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-180" />

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-181">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-182">
          Support Our Mission
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto" data-id="element-183">
          Your contribution helps us protect player rights, conduct vital
          research, and provide support to those in need. Join us in creating a
          fair gaming space.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-184">
          <Button variant="primary" size="lg" className="text-lg px-10 py-6 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all" data-id="element-185">
            Donate Now
          </Button>
        </motion.div>
      </div>
    </section>;
}